import {
  HomeOutlined,
  BankOutlined,
  EnvironmentOutlined,
  ProjectOutlined,
  TeamOutlined,
  DollarOutlined,
  BookOutlined,
  HeartOutlined,
  CalendarOutlined,
  CoffeeOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

// Components
import Banner from "../components/pages/home/Banner";
import Announcement from "../components/pages/home/Announcement";
import ProgrammeHighlights from "../components/pages/home/ProgrammeHighlights";
import Thoughts from "../components/pages/home/Thoughts";
import Figures from "../components/pages/home/Figures";
import Officers from "../components/pages/home/Officers";
import Progress from "../components/pages/home/Progress";
// import StateAdmin from "../components/pages/home/StateAdmin";
// import DistrictAdmin from "../components/pages/home/DistrictAdmin";
// import PanchayatAdmin from "../components/pages/home/PanchayatAdmin";
import Gallery from "../components/pages/home/Gallery";
import Advertisement from "../components/pages/home/Advertisement";
// import QuickLinks from "../components/pages/home/QuickLinks";
// import FooterItems from "../components/pages/home/FooterItems";
// import FooterCategories from "../components/pages/home/FooterCategories";
import BudgetSummary from "../components/pages/finance/BudgetSummary";
import Income from "../components/pages/finance/Income";
import Expenditure from "../components/pages/finance/Expenditure";
import FinancialReportDoc from "../components/pages/finance/FinancialReportDoc";
import VillageInfo from "../components/pages/village/VillageInfo";
import VillageHistory from "../components/pages/village/VillageHistory";
import Projects from "../components/pages/projects/Projects";
import ProjectGallery from "../components/pages/projects/ProjectGallery";
import Schemes from "../components/pages/projects/Schemes";
// import Complaints from "../components/pages/citizens/Complaints";
import TaxPayment from "../components/pages/citizens/TaxPayment";
import DigitalLibrary from "../components/pages/library/DigitalLibrary";
import VillageBooks from "../components/pages/library/VillageBooks";
import Ceremony from "../components/pages/events/Ceremony";
import BirthdayWishes from "../components/pages/events/BirthdayWishes";
import Donations from "../components/pages/donations/Donations";
import DonorListDocuments from "../components/pages/donations/DonorListDocuments";
import OfficeAddress from "../OfficeAddress";
import DownloadableDocuments from "../components/pages/library/DownloadableDocuments";
import VillageReportDocuments from "../components/pages/prosperous/VillageReportDocuments";

// Config with translation keys - labels object has { en, mr } for each language
const appConfig = [
  {
    key: "main-page",
    icon: <HomeOutlined />,
    label: { en: "Main Page", mr: "मुख्य पृष्ठ" },
    items: [
      { key: "banner", label: { en: "Banner", mr: "बॅनर" }, component: Banner },
      {
        key: "announcement",
        label: { en: "Announcements", mr: "घोषणा" },
        component: Announcement,
      },
      {
        key: "programme-highlights",
        label: { en: "Programme Highlights", mr: "कार्यक्रम" },
        component: ProgrammeHighlights,
      },
      {
        key: "thought",
        label: { en: "Thoughts", mr: "विचार" },
        component: Thoughts,
      },
      {
        key: "important-figures",
        label: { en: "Important Figures", mr: "महत्वाचे आकडे" },
        component: Figures,
      },
      {
        key: "progress",
        label: { en: "Progress", mr: "प्रगती मीटर" },
        component: Progress,
      },
      // {
      //   key: "state-admin",
      //   label: {
      //     en: "State Administrative Members",
      //     mr: "राज्य प्रशासकीय सदस्य",
      //   },
      //   component: StateAdmin,
      // },
      // {
      //   key: "district-admin",
      //   label: {
      //     en: "District Administrative Members",
      //     mr: "जिल्हा प्रशासकीय सदस्य",
      //   },
      //   component: DistrictAdmin,
      // },
      // {
      //   key: "panchayat-admin",
      //   label: {
      //     en: "Panchayat Administrative Members",
      //     mr: "पंचायत प्रशासकीय सदस्य",
      //   },
      //   component: PanchayatAdmin,
      // },
      {
        key: "officers",
        label: { en: "Officers", mr: "अधिकारी" },
        component: Officers,
      },
      // {
      //   key: "quick-links",
      //   label: { en: "Quick Links", mr: "द्रुत दुवे" },
      //   component: QuickLinks,
      // },
      {
        key: "photo-gallery",
        label: { en: "Photo Gallery", mr: "फोटो गॅलरी" },
        component: Gallery,
      },
      {
        key: "advertisement",
        label: { en: "Advertisement", mr: "जाहिरात" },
        component: Advertisement,
      },
      // {
      //   key: "footer-categories",
      //   label: { en: "Footer Categories", mr: "फूटर वर्गवारी" },
      //   component: FooterCategories,
      // },
      // {
      //   key: "footer-items",
      //   label: { en: "Footer Items", mr: "फूटर आयटम" },
      //   component: FooterItems,
      // },
    ],
  },
  {
    key: "panchayat",
    icon: <BankOutlined />,
    label: { en: "Our Panchayat", mr: "आमची ग्रामपंचायत" },
    items: [
      {
        key: "village-history",
        label: { en: "Village History", mr: "गाव इतिहास" },
        component: VillageHistory,
      },
      {
        key: "office-address",
        label: { en: "Office Address", mr: "कार्यालय पत्ता" },
        component: OfficeAddress,
      },
    ],
  },
  {
    key: "village",
    icon: <EnvironmentOutlined />,
    label: { en: "Your Village", mr: "आपले गाव" },
    items: [
      {
        key: "my-village",
        label: { en: "My Village", mr: "माझे गाव" },
        component: VillageInfo,
      },
    ],
  },
  {
    key: "projects-section",
    icon: <ProjectOutlined />,
    label: { en: "Projects & Schemes", mr: "योजना आणि प्रकल्प" },
    items: [
      {
        key: "projects",
        label: { en: "Projects", mr: "प्रकल्प" },
        component: Projects,
      },
      {
        key: "project-gallery",
        label: { en: "Project Gallery", mr: "प्रकल्प गॅलरी" },
        component: ProjectGallery,
      },
      {
        key: "schemes",
        label: { en: "Schemes", mr: "योजना" },
        component: Schemes,
      },
    ],
  },
  {
    key: "citizens",
    icon: <TeamOutlined />,
    label: { en: "Citizen Services", mr: "नागरिक सेवा" },
    items: [
      // {
      //   key: "complaints",
      //   label: { en: "Complaints", mr: "तक्रारी" },
      //   component: Complaints,
      // },
      {
        key: "tax-payment",
        label: { en: "Tax Payment", mr: "कर भरने" },
        component: TaxPayment,
      },
      {
        key: "downloadable-documents",
        label: { en: "Tax Payment Documents", mr: "कर भरणा दस्तऐवज" },
        component: DownloadableDocuments,
      },
    ],
  },
  {
    key: "finance",
    icon: <DollarOutlined />,
    label: { en: "Finance", mr: "अर्थ संकल्प" },
    items: [
      {
        key: "budget-summary",
        label: { en: "Budget Summary", mr: "अर्थसंकल्प सारांश" },
        component: BudgetSummary,
      },
      {
        key: "income",
        label: { en: "Income", mr: "उत्पन्न" },
        component: Income,
      },
      {
        key: "expenditure",
        label: { en: "Expenditure", mr: "खर्च" },
        component: Expenditure,
      },
      {
        key: "financial-report-doc",
        label: { en: "Financial Report", mr: "आर्थिक अहवाल" },
        component: FinancialReportDoc,
      },
    ],
  },
  {
    key: "library",
    icon: <BookOutlined />,
    label: { en: "Digital Library", mr: "डिजिटल ग्रंथालय" },
    items: [
      {
        key: "digital-library",
        label: { en: "Digital Library", mr: "डिजिटल ग्रंथालय" },
        component: DigitalLibrary,
      },
      {
        key: "village-books",
        label: { en: "Village Books", mr: "गावाची पुस्तके" },
        component: VillageBooks,
      },
    ],
  },
  {
    key: "donors",
    icon: <HeartOutlined />,
    label: { en: "Donors", mr: "देणगीदार" },
    items: [
      {
        key: "donations",
        label: { en: "Donations", mr: "देणग्या" },
        component: Donations,
      },
      {
        key: "donor-list-documents",
        label: { en: "Donor List Documents", mr: "देणगीदारांची यादी" },
        component: DonorListDocuments,
      },
    ],
  },
  {
    key: "events",
    icon: <CalendarOutlined />,
    label: { en: "Events", mr: "समारंभ" },
    items: [
      {
        key: "ceremony",
        label: { en: "Ceremonies", mr: "समारंभ" },
        component: Ceremony,
      },
    ],
  },
  {
    key: "hangout",
    icon: <CoffeeOutlined />,
    label: { en: "Village Hangout", mr: "गावचा कट्टा" },
    items: [
      {
        key: "birthday-wishes",
        label: { en: "Birthday Wishes", mr: "वाढदिवस शुभेच्छा" },
        component: BirthdayWishes,
      },
    ],
  },
  {
    key: "prosperous",
    icon: <TrophyOutlined />,
    label: { en: "Prosperous Panchayat", mr: "समृद्ध ग्रामपंचायत" },
    items: [
      {
        key: "report",
        label: {
          en: "CM Prosperous Panchayat Raj Abhiyan",
          mr: "मुख्यमंत्री समृद्ध पंचायत राज अभियान",
        },
        component: VillageReportDocuments,
      },
    ],
  },
];

// Helper to get label based on language
const getLabel = (labelObj, lang) => {
  if (typeof labelObj === "string") return labelObj;
  return labelObj[lang] || labelObj.en || "";
};

// Generate menu items for Ant Design Menu
export const getMenuItems = (lang = "en") =>
  appConfig.map((section) => ({
    key: section.key,
    icon: section.icon,
    label: getLabel(section.label, lang),
    children: section.items.map((item) => ({
      key: item.key,
      label: getLabel(item.label, lang),
    })),
  }));

// Generate routes object for App.js
export const getRoutes = () => {
  const routes = {};
  appConfig.forEach((section) => {
    section.items.forEach((item) => {
      routes[item.key] = item.component;
    });
  });
  return routes;
};

// Get flat list for search
export const getFlatItems = (lang = "en") =>
  appConfig.flatMap((section) =>
    section.items.map((item) => ({
      key: item.key,
      label: getLabel(item.label, lang),
      parent: getLabel(section.label, lang),
    }))
  );

export default appConfig;
